import { Route, Routes } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import {
	AdminList,
	AdminComplaints,
	DetailsComplainAdmin,
  CompanyPage,
  ClientListPage,
  ParrainageList,
  FinancementSuperAdmin,
  ContenairePage
} from '../pages/superAdmin';

const SuperAdminRoutes = () => {
	return (
		<Routes>
			<Route exact path='/' element={<CompanyPage />} />
      <Route exact path='/superadmin/clients/:page' element={<ClientListPage />} />
			<Route exact path='/superadmin/users/:page' element={<AdminList />} />
			<Route exact path='/superadmin/complaints/:page' element={<AdminComplaints />} />
      <Route exact path='/superadmin/companies/:page' element={<CompanyPage />} />
      <Route exact path='/superadmin/parrainages/:page' element={<ParrainageList />} />
      <Route exact path='/superadmin/financements/:page' element={<FinancementSuperAdmin />} />
      <Route exact path='/superadmin/contenaires/:page' element={<ContenairePage />} />
			<Route
				exact
				path='/superadmin/complaints/complain_details/:page/:id'
				element={<DetailsComplainAdmin />}
			/>
			<Route exact path='*' element={<NotFound />} />
		</Routes>
	);
};

export default SuperAdminRoutes;
